import { apiClient } from '../client'
import type {
  CreateCustomerContactRequest,
  CreateCustomerContractRequest,
  CreateCustomerRequest,
  CreateCustomerSiteRequest,
  Customer,
  CustomerContact,
  CustomerContract,
  CustomerDetail,
  CustomerPageParams,
  CustomerPageResponse,
  CustomerSite,
} from '../types/customer'

export async function getCustomerPage(params: CustomerPageParams = {}): Promise<CustomerPageResponse> {
  const search = new URLSearchParams()
  search.set('page', String(params.page ?? 0))
  search.set('size', String(params.size ?? 20))
  if (params.keyword) search.set('keyword', params.keyword)
  if (params.status) search.set('status', params.status)
  return apiClient.get<CustomerPageResponse>(`/api/customers?${search.toString()}`)
}

export function getCustomer(id: number): Promise<CustomerDetail> {
  return apiClient.get<CustomerDetail>(`/api/customers/${id}`)
}

export function createCustomer(data: CreateCustomerRequest): Promise<Customer> {
  return apiClient.post<Customer>('/api/customers', data)
}

export function updateCustomer(id: number, data: CreateCustomerRequest): Promise<Customer> {
  return apiClient.put<Customer>(`/api/customers/${id}`, data)
}

export function createCustomerSite(id: number, data: CreateCustomerSiteRequest): Promise<CustomerSite> {
  return apiClient.post<CustomerSite>(`/api/customers/${id}/sites`, data)
}

export function createCustomerContact(id: number, data: CreateCustomerContactRequest): Promise<CustomerContact> {
  return apiClient.post<CustomerContact>(`/api/customers/${id}/contacts`, data)
}

export function createCustomerContract(id: number, data: CreateCustomerContractRequest): Promise<CustomerContract> {
  return apiClient.post<CustomerContract>(`/api/customers/${id}/contracts`, data)
}

export function linkDeviceAsset(id: number, deviceId: number): Promise<void> {
  return apiClient.post<void>(`/api/customers/${id}/device-assets/${deviceId}`, {})
}
